// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__34rBE","savePackageButton":"ClientWallet_savePackageButton__1pOaM"};